import { useState, useRef } from 'react';

const Faq = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const contentRef = useRef([]); // To get height of accordion content

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className=' pt-8 mb-4 p-3 '>
      <h1 className=' text-black font-bold text-4xl text-center'>FAQ's</h1>

      <div className=" container accordion mt-5 " id="accordionExample">

        {items.map((item, index) => (
          <div key={index} className="accordion-item  ">
            <h2 className="accordion-header">
              <button
                className={`accordion-button my-3 ${activeIndex === index ? 'bg-[orange] text-white border-l-2 border-[#e3e8eaed]' : 'bg-[#e3e8eaed] text-black border-l-2 border-[orange]'
                  } border-b-3 flex justify-between items-center w-full py-2  sm:py-4 px-4  sm:px-6 text-left text-lg  focus:outline-none`}
                type="button"
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
                <span
                  className={`transform transition-transform duration-200 ${activeIndex === index ? 'rotate-180' : 'rotate-0'
                    }`}
                >
                  ▼
                </span>
              </button>
            </h2>
            <div
              ref={(el) => (contentRef.current[index] = el)}
              style={{
                maxHeight: activeIndex === index ? contentRef.current[index]?.scrollHeight : 0,
              }}
              className={`accordion-collapse overflow-hidden w-full transition-max-height duration-500 ease-in-out`}
            >
              <div className="accordion-body py-2  sm:py-4 px-4  sm:px-6  text-black bg-[#eee] p-5 shadow-[0_0_6px_rgba(0,0,0,0.1)] border">
                {item.content}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
